import { render, staticRenderFns } from "./TemaDinamicoForm.vue?vue&type=template&id=0f71425c"
import script from "./TemaDinamicoForm.vue?vue&type=script&lang=js"
export * from "./TemaDinamicoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports